import { Link } from "react-router-dom";
import { siteHome } from "@/lib/site";

export const BlogHeader = () => (
  <header className="sticky top-0 z-30 border-b border-[#e2e0d6] bg-[#f6f4ee]/95 backdrop-blur">
    <nav className="mx-auto flex h-[68px] max-w-[1240px] items-center justify-between gap-4 px-5">
      <Link to={siteHome()} className="flex items-center gap-2 font-['Georgia'] text-[20px] text-[#17201b]" data-testid="blog-brand">
        <img src="/peacock-feather-logo-transparent.png" alt="" aria-hidden="true" className="h-9 w-auto" /> Art of Resume
      </Link>
      <div className="flex items-center gap-5 text-[14px] font-semibold text-[#26302b]">
        <Link to="/blog" data-testid="blog-nav-blog" className="hover:text-[#0f7c78]">Blog</Link>
        <Link to="/resume-service" data-testid="blog-nav-studio" className="hidden hover:text-[#0f7c78] sm:inline">Resume Studio</Link>
        <Link to={siteHome()} data-testid="blog-nav-analyze" className="rounded-full bg-[#17201b] px-4 py-2 text-white transition-colors hover:bg-[#0f7c78]">Analyze my resume</Link>
      </div>
    </nav>
  </header>
);

export const BlogFooter = () => (
  <footer className="mt-24 border-t border-[#e2e0d6] py-10 text-center text-[14px] text-[#4c5a53]">
    <p className="font-['Georgia'] text-[18px] text-[#17201b]">Art of Resume</p>
    <p className="mt-1">HR will get back ... this time</p>
    <p className="mt-4 flex justify-center gap-5"><Link to="/blog">Blog</Link><Link to="/resume-service">Resume Studio</Link><Link to="/privacy">Privacy</Link></p>
  </footer>
);
